"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var numeral = require("numeral");
// Exported Functions
function roundDollar(dollars) {
    return Math.ceil(dollars);
}
exports.roundDollar = roundDollar;
function isValidNumber(validNumber) {
    return !(validNumber === null || isNaN(validNumber));
}
exports.isValidNumber = isValidNumber;
function isValidDollarAmount(dollars) {
    return isValidNumber(dollars);
}
exports.isValidDollarAmount = isValidDollarAmount;
function invalidDollarDisplayValue() {
    return '$' + invalidNumberDisplayValue();
}
exports.invalidDollarDisplayValue = invalidDollarDisplayValue;
function invalidNumberDisplayValue() {
    return '--';
}
exports.invalidNumberDisplayValue = invalidNumberDisplayValue;
function formatDollars(dollars, defaultString) {
    if (isValidNumber(dollars)) {
        return numeral(roundDollar(dollars)).format('$0,000');
    }
    return defaultString ? defaultString : invalidDollarDisplayValue();
}
exports.formatDollars = formatDollars;
function formatDollarsAndCents(dollars, defaultString) {
    if (isValidNumber(dollars)) {
        return numeral(dollars).format('$0,000.00');
    }
    return defaultString ? defaultString : invalidDollarDisplayValue();
}
exports.formatDollarsAndCents = formatDollarsAndCents;
function formatMonthlyPayment(dollars, defaultString) {
    if (isValidNumber(dollars)) {
        var dollarsRounded = Math.round(dollars);
        return numeral(dollarsRounded).format('$0,000');
    }
    return defaultString ? defaultString : invalidDollarDisplayValue();
}
exports.formatMonthlyPayment = formatMonthlyPayment;
function formatNumber(numberNeedingFormat) {
    return numeral(numberNeedingFormat).format('0,000');
}
exports.formatNumber = formatNumber;
function formatTerm(term, treatNullOrUndefinedAsInvalid) {
    if (treatNullOrUndefinedAsInvalid === void 0) { treatNullOrUndefinedAsInvalid = true; }
    if (!term && term !== 0 && term !== '0') {
        return treatNullOrUndefinedAsInvalid ? invalidNumberDisplayValue() : '';
    }
    return "" + term;
}
exports.formatTerm = formatTerm;
function formatMiles(value) {
    var formattedNumber = formatNumber(value);
    return formattedNumber + " mi";
}
exports.formatMiles = formatMiles;
function formatCurrencyAmount(amount) {
    return isValidDollarAmount(amount) ? formatDollars(amount) : invalidDollarDisplayValue();
}
exports.formatCurrencyAmount = formatCurrencyAmount;
function formatAPR(apr) {
    if (isNaN(apr)) {
        return '-';
    }
    return numeral(apr).format('0.00');
}
exports.formatAPR = formatAPR;
;
function formatDate(date) {
    var finalDay = (isNaN(date.getTime())) ? new Date() : date;
    var month = (finalDay.getMonth() + 1) > 9 ? (finalDay.getMonth() + 1) : '0' + (finalDay.getMonth() + 1);
    var day = (finalDay.getDate() > 9) ? finalDay.getDate() : '0' + finalDay.getDate();
    return month + '/' + day + '/' + finalDay.getFullYear();
}
exports.formatDate = formatDate;
function formatLongDisclaimer(data) {
    var downPayment = formatDollars(data.downPayment);
    var offerPrice = formatDollars(data.offerPrice);
    var totalPaymentAmount = formatDollars(data.totalPaymentAmount);
    var disclaimerText = data.hasOfferPriceChanged ?
        "*Estimated payment based on your asking price of "
        : "*Estimated payment based on vehicle price of ";
    if (data.offerType === 'finance') {
        var monthlyAprCost = formatDollarsAndCents(data.monthlyAprCost);
        // tslint:disable-next-line:max-line-length
        disclaimerText +=
            offerPrice + " at " + data.apr + "% APR for " + data.termMonths + " months at " + monthlyAprCost + "/month, per $1,000 financed, " + downPayment + " down for qualified buyers, " + totalPaymentAmount + " total of all payments. " + data.cludes + " tax, title, registration, and license. Contingent upon dealer\u2019s acceptance of these terms. Excludes leases and balloon contracts. Available only at participating dealers by " + data.lender + ". Offer may expire at any time without notification. See dealer for details. Subject to credit approval by lender. Rate applies only to vehicle shown. Not everyone will qualify.";
    }
    else if (data.offerType === 'lease') {
        var annualMiles = formatNumber(data.annualMiles);
        var monthlyPayment = formatMonthlyPayment(data.monthlyPayment);
        var acqLoanFee = formatDollars(data.acqLoanFee);
        var capCostTotal = formatDollars(data.capCostTotal);
        var capCostReduction = formatDollars(data.capCostReduction);
        var securityDeposit = formatDollars(data.securityDeposit);
        var excessMileageCharge = formatDollarsAndCents(data.excessMileageCharge);
        disclaimerText = data.hasOfferPriceChanged ?
            "*Estimated payment based on your asking price of "
            : "*Estimated payment based on advertised price of ";
        // tslint:disable-next-line:max-line-length
        disclaimerText +=
            offerPrice + " at " + annualMiles + " miles/year for " + data.termMonths + " months with " + downPayment + " down, " + acqLoanFee + " acquisition fee, including the gross capitalized cost of " + capCostTotal + ". " + data.cludes + " tax, title, registration, and license. Total monthly payments equal " + totalPaymentAmount + ". Cash down includes " + capCostReduction + " capitalized cost reduction, a required security deposit of " + securityDeposit + ", and first month\u2019s lease payment of " + monthlyPayment + ". " + excessMileageCharge + " charge per mile over " + annualMiles + " miles per year. For qualified buyers. Contingent upon dealer\u2019s acceptance of these terms. Available only at participating dealers by " + data.lender + ". Early termination fees may apply. Lessee is responsible for maintenance, insurance, repair, and excess wear/tear at end of lease. Lessee will not be liable for extra charges if realized vehicle value is lower than residual value at end of lease. Lessee may incur penalties and additional charges for delinquent payments. See " + data.dealerName + " for complete details on this and other offers.";
    }
    else {
        disclaimerText += offerPrice + ". ";
        if (data.taxesAndFeesTotal) {
            disclaimerText += data.cludes + " " + formatDollars(data.taxesAndFeesTotal) + " in fees";
            var includesTaxes = data.totalTax ? " and taxes. " : ". ";
            disclaimerText +=
                includesTaxes + "Final transaction may include additional fees/charges and taxes. ";
        }
        disclaimerText +=
            // tslint:disable-next-line:max-line-length
            "This is not an offer or sales contract and is contingent upon dealer\u2019s acceptance of these terms. See dealer for terms of purchase.";
    }
    if (data.programEndDate && data.offerType !== 'cash') {
        var programEndDate = formatDate(new Date(data.programEndDate));
        disclaimerText = disclaimerText + ' Payment Expires: ' + programEndDate + '.';
    }
    return disclaimerText;
}
exports.formatLongDisclaimer = formatLongDisclaimer;
function formatShortDisclaimer(data) {
    var downPayment = formatDollars(data.downPayment);
    var offerPrice = formatDollars(data.offerPrice);
    var disclaimerText = '';
    if (data.offerType === 'finance') {
        disclaimerText = data.hasOfferPriceChanged ?
            "*Est. pmt. based on your asking price of "
            : "*Est. pmt. based on vehicle price of ";
        // tslint:disable-next-line:max-line-length
        disclaimerText +=
            offerPrice + " at " + data.apr + "% APR for " + data.termMonths + " mos w/ " + downPayment + " down for qualified buyers. Contingent upon dealer\u2019s acceptance of these terms. Terms may vary.";
    }
    else if (data.offerType === 'lease') {
        var annualMiles = formatNumber(data.annualMiles);
        disclaimerText = data.hasOfferPriceChanged ?
            "*Est. pmt. based on your asking price of "
            : "*Est. pmt. based on adv. price of ";
        // tslint:disable-next-line:max-line-length
        disclaimerText +=
            offerPrice + " at " + annualMiles + " mi/yr for " + data.termMonths + " mos with " + downPayment + " down for qualified buyers. Contingent upon dealer\u2019s acceptance of these terms. Terms may vary.";
    }
    else {
        if (data.taxesAndFeesTotal) {
            // tslint:disable-next-line:max-line-length
            disclaimerText +=
                "*" + data.cludes + " " + formatDollars(data.taxesAndFeesTotal) + " in fees";
            var includesTaxes = data.totalTax ? " and taxes. " : ". ";
            disclaimerText +=
                includesTaxes + "Final transaction may include additional fees/charges and taxes.";
        }
        else {
            disclaimerText += "*" + data.cludes + " tax, title, registration and certain fees/charges.";
        }
    }
    if (data.programEndDate && data.offerType !== 'cash') {
        var programEndDate = formatDate(new Date(data.programEndDate));
        disclaimerText = disclaimerText + ' Payment Expires: ' + programEndDate + '.';
    }
    return disclaimerText;
}
exports.formatShortDisclaimer = formatShortDisclaimer;
function capitalize(text) {
    if (text) {
        return text.length ? text[0].toLocaleUpperCase() + text.substr(1) : text;
    }
    else {
        return text;
    }
}
exports.capitalize = capitalize;
